import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import StackedBarGraph from "../../../general/StackedBarGraph";
import styles from "./InitialPageL1.module.css";
import DistrictInfo from "./general/DistrictInfo";
import { InitialPageStore } from "./InitialPageStore";

function InitialPageL1({ distrito, onDistrictMapChange }) {
  const [contProdAgropec, setcontProdAgropec] = useState(null);

  const setProdAgropecImage = InitialPageStore(
    (state) => state.setProdAgropecImage
  );

  const setMapImage = InitialPageStore((state) => state.setMapImage);

  useEffect(() => {
    Api.getImoveisPorProdAgropec(distrito).then((value) => {
      setcontProdAgropec(value);
    });
  }, [distrito]);

  return (
    <div className={styles.initialPageL1}>
      <DistrictInfo
        distrito={distrito}
        onDistrictMapChange={onDistrictMapChange}
        setMapImage={setMapImage}
      />
      <div className={styles.barGraph}>
        {contProdAgropec && (
          <div className={styles.graph}>
            <StackedBarGraph
              data={contProdAgropec}
              isProdAgropec={true}
              onImageReady={setProdAgropecImage}
              text="NÚMERO DE IMÓVEIS POR PRODUÇÃO AGROPECUÁRIA"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default InitialPageL1;
